import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interface ActionPayload {
//   permissions: {
//     DataBackFill: {
//       canRead: boolean;
//       canAdd: boolean;
//       canUpdate: boolean;
//       canDeploy: boolean;
//       canRefresh: boolean;
//       canRetry: boolean;
//       canDelete: boolean;
//     };
//     Ethernet: {
//       canRead: boolean;
//       canAdd: boolean;
//       canUpdate: boolean;
//       canDeploy: boolean;
//       canRefresh: boolean;
//       canRetry: boolean;
//       canDelete: boolean;
//     };
//     DeviceDetails: {
//       canRead: boolean;
//       canAdd: boolean;
//       canUpdate: boolean;
//       canDeploy: boolean;
//       canRefresh: boolean;
//       canRetry: boolean;
//       canDelete: boolean;
//     };
//     FireWallSettings: {
//       canRead: boolean;
//       canAdd: boolean;
//       canUpdate: boolean;
//       canDeploy: boolean;
//       canRefresh: boolean;
//       canRetry: boolean;
//       canDelete: boolean;
//     };
//     ModbusClient: {
//       canRead: boolean;
//       canAdd: boolean;
//       canUpdate: boolean;
//       canDeploy: boolean;
//       canRefresh: boolean;
//       canRetry: boolean;
//       canDelete: boolean;
//     };
//     ModbusClientDevice: {
//       canRead: boolean;
//       canAdd: boolean;
//       canUpdate: boolean;
//       canDeploy: boolean;
//       canRefresh: boolean;
//       canRetry: boolean;
//       canDelete: boolean;
//     };
//     PortForwarding: {
//       canRead: boolean;
//       canAdd: boolean;
//       canUpdate: boolean;
//       canDeploy: boolean;
//       canRefresh: boolean;
//       canRetry: boolean;
//       canDelete: boolean;
//     };
//     PortForwardingConfig: {
//       canRead: boolean;
//       canAdd: boolean;
//       canUpdate: boolean;
//       canDeploy: boolean;
//       canRefresh: boolean;
//       canRetry: boolean;
//       canDelete: boolean;
//     };
//   };
// }

type PermissionSet = {
  canRead: boolean;
  canAdd: boolean;
  canUpdate: boolean;
  canDeploy: boolean;
  canRefresh: boolean;
  canRetry: boolean;
  canDelete: boolean;
};

const permissionKeys: (keyof PermissionSet)[] = [
  "canRead",
  "canAdd",
  "canUpdate",
  "canDeploy",
  "canRefresh",
  "canRetry",
  "canDelete",
];

type ActionPayload = {
  permissions: Record<string, PermissionSet>;
};

const initialState: ActionPayload = {
  permissions: {
    DataBackFill: {
      canRead: true,
      canAdd: true,
      canUpdate: true,
      canDeploy: true,
      canRefresh: true,
      canRetry: true,
      canDelete: true,
    },
    Ethernet: {
      canRead: true,
      canAdd: true,
      canUpdate: true,
      canDeploy: true,
      canRefresh: true,
      canRetry: true,
      canDelete: true,
    },
    DeviceDetails: {
      canRead: true,
      canAdd: true,
      canUpdate: true,
      canDeploy: true,
      canRefresh: true,
      canRetry: true,
      canDelete: true,
    },
    FireWallSettings: {
      canRead: true,
      canAdd: true,
      canUpdate: true,
      canDeploy: true,
      canRefresh: true,
      canRetry: true,
      canDelete: true,
    },
    ModbusClient: {
      canRead: true,
      canAdd: true,
      canUpdate: true,
      canDeploy: true,
      canRefresh: true,
      canRetry: true,
      canDelete: true,
    },
    ModbusClientDevice: {
      canRead: true,
      canAdd: true,
      canUpdate: true,
      canDeploy: true,
      canRefresh: true,
      canRetry: true,
      canDelete: true,
    },
    PortForwarding: {
      canRead: true,
      canAdd: true,
      canUpdate: true,
      canDeploy: true,
      canRefresh: true,
      canRetry: true,
      canDelete: true,
    },
    PortForwardingConfig: {
      canRead: true,
      canAdd: true,
      canUpdate: true,
      canDeploy: true,
      canRefresh: true,
      canRetry: true,
      canDelete: true,
    },
  },
};

const permisssionSlice = createSlice({
  name: "toaster",
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<any>) => {
      if (action?.payload?.length) {
        state.permissions = action.payload.reduce(
          (acc: any, item: any) => {
            const permissionString = item.permission;
            const permissionObject: PermissionSet = Object.fromEntries(
              permissionKeys.map((key, index) => [
                key,
                permissionString[index] === "1",
              ]),
            ) as PermissionSet;

            acc[item.name] = permissionObject;
            return acc;
          },
          {} as Record<string, PermissionSet>,
        );
      }
    },
  },
});

export const { setPermissions } = permisssionSlice.actions;
export default permisssionSlice.reducer;
